import React from 'react';

import { ExpandTableColumn } from './ExpandTable';

interface ExpandTableMobileItemProps {
    tableHeader: ExpandTableColumn[];
    rowElements: string[];
}

const ExpandTableMobileItem: React.FC<ExpandTableMobileItemProps> = ({ tableHeader, rowElements }) => {
    return (
        <tr>
            {rowElements.map((rowElement, i) => (
                <td data-label={tableHeader[i].label} key={tableHeader[i].id}>
                    {rowElement}
                </td>
            ))}
        </tr>
    );
};

export default ExpandTableMobileItem;
